(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4945,1581],{

/***/ 2472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SingleServicePage; }
/* harmony export */ });
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_components_shared_Seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1581);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var SingleService = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1608), __webpack_require__.e(1664), __webpack_require__.e(423)]).then(__webpack_require__.bind(__webpack_require__, 423));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(423)];
    }
  }
});
var __N_SSG = true;
function SingleServicePage(_ref) {
  var _data$singleServiceDa, _data$singleServiceDa2, _data$singleServiceDa3, _data$singleServiceDa4;

  var data = _ref.data,
      _ref$appSetting = _ref.appSetting,
      appSetting = _ref$appSetting === void 0 ? {} : _ref$appSetting,
      footerSettings = _ref.footerSettings;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var locale = router.locale;
  var customMeta = [{
    name: "title",
    content: data === null || data === void 0 ? void 0 : (_data$singleServiceDa = data.singleServiceData) === null || _data$singleServiceDa === void 0 ? void 0 : (_data$singleServiceDa2 = _data$singleServiceDa.title) === null || _data$singleServiceDa2 === void 0 ? void 0 : _data$singleServiceDa2[locale]
  }, {
    name: "description",
    content: data === null || data === void 0 ? void 0 : (_data$singleServiceDa3 = data.singleServiceData) === null || _data$singleServiceDa3 === void 0 ? void 0 : (_data$singleServiceDa4 = _data$singleServiceDa3.description) === null || _data$singleServiceDa4 === void 0 ? void 0 : _data$singleServiceDa4[locale]
  }];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_shared_Seo__WEBPACK_IMPORTED_MODULE_2__["default"], {
      metaData: customMeta,
      appSetting: _objectSpread(_objectSpread({}, appSetting), footerSettings),
      pageUrl:  true ? window.location.href : 0
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(SingleService, {
        data: data
      })
    })]
  });
}

/***/ }),

/***/ 1581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);





var Seo = function Seo(_ref) {
  var _appSetting$AppSettin, _appSetting$socials, _appSetting$socials$t;

  var _ref$metaData = _ref.metaData,
      metaData = _ref$metaData === void 0 ? [] : _ref$metaData,
      _ref$appSetting = _ref.appSetting,
      appSetting = _ref$appSetting === void 0 ? {} : _ref$appSetting,
      _ref$pageUrl = _ref.pageUrl,
      pageUrl = _ref$pageUrl === void 0 ? "" : _ref$pageUrl;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var locale = router.locale;
  var metaTitle = metaData === null || metaData === void 0 ? void 0 : metaData.find(function (meta) {
    return meta.name === "title";
  });
  var description = metaData === null || metaData === void 0 ? void 0 : metaData.find(function (meta) {
    return meta.name === "description";
  });

  var _ref2 = appSetting || {},
      appName_EN = _ref2.appName_EN,
      appName = _ref2.appName;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
    title: metaTitle === null || metaTitle === void 0 ? void 0 : metaTitle.content,
    description: (description === null || description === void 0 ? void 0 : description.content) || "" // canonical={pageUrl ? pageUrl : ""}
    ,
    openGraph: {
      title: metaTitle === null || metaTitle === void 0 ? void 0 : metaTitle.content,
      description: description === null || description === void 0 ? void 0 : description.content,
      type: "website",
      locale: locale,
      url: pageUrl ? pageUrl : "",
      images: [{
        url: "".concat("https://mu7.ejjadh.info", "/").concat(appSetting === null || appSetting === void 0 ? void 0 : (_appSetting$AppSettin = appSetting.AppSetting) === null || _appSetting$AppSettin === void 0 ? void 0 : _appSetting$AppSettin.appLogo),
        width: 800,
        height: 600,
        alt: metaTitle === null || metaTitle === void 0 ? void 0 : metaTitle.content
      }]
    },
    twitter: {
      handle: "@".concat(appSetting === null || appSetting === void 0 ? void 0 : (_appSetting$socials = appSetting.socials) === null || _appSetting$socials === void 0 ? void 0 : (_appSetting$socials$t = _appSetting$socials.twitter) === null || _appSetting$socials$t === void 0 ? void 0 : _appSetting$socials$t.split("https://x.com/")[1]),
      site: "https://x.com",
      cardType: "summary_large_image"
    }
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Seo);

/***/ }),

/***/ 5033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[slug]",
      function () {
        return __webpack_require__(2472);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,9774,2888,179], function() { return __webpack_exec__(5033); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);